import { Report } from "./reporting";
import Cookies from "../utils/cookies";
import { API } from "./API";
import getScriptParamsByURL from "../utils/getScriptParamsByURL";
const CART_TOKEN_COOKIE_NAME = "cart";
const SERP_CART_TOKEN = '__isp_cart_last_known';
const SERP_CART_TOKEN_LS = '__isp_cart';
function removeKeyFromToken(platform, token) {
    var _a;
    if (platform === 'Shopify') {
        return (_a = token.split('?key=')) === null || _a === void 0 ? void 0 : _a[0];
    }
    return token;
}
export const Cart = {
    getToken: (platform) => {
        const cookies = new Cookies();
        /* try the shopify cookie */
        let data = platform === "Shopify" && cookiesGetter(cookies, CART_TOKEN_COOKIE_NAME);
        if (data) {
            return removeKeyFromToken(platform, data);
        }
        /* try magento getter */
        data = platform === "Magento" && getMagentoCartToken();
        if (data) {
            return data;
        }
        /* try WooCommerce getter */
        data = platform === "WooCommerce" && getWooCommerceCartToken();
        if (data) {
            return data;
        }
        /* try the our cookie next */
        data = cookiesGetter(cookies, SERP_CART_TOKEN);
        if (data) {
            return removeKeyFromToken(platform, data);
        }
        /* use common local storage as the last fallback */
        data = localStorageGetter(SERP_CART_TOKEN_LS);
        if (data) {
            return removeKeyFromToken(platform, data);
        }
        /* Bigcommerce global cart token fetcher - next round will catch it */
        if (platform === "BigCommerce") {
            setBigcommerceCartToken();
        }
        return undefined;
    },
    saveToken(token, platform) {
        const cookies = new Cookies();
        localStorage.setItem(SERP_CART_TOKEN_LS, token);
        if (platform === "Shopify") {
            cookies.set(SERP_CART_TOKEN, token);
        }
    },
    report: (base) => {
        return Report(Object.assign(Object.assign({}, base), { site: true, params: {
                cart: 1
            } }));
    }
};
function localStorageGetter(key) {
    const data = localStorage.getItem(key);
    if (!data || !data.trim() || data === "null" || data === "undefined") {
        return null;
    }
    return data;
}
function cookiesGetter(cookies, key) {
    if (!(cookies.has(key))) {
        return null;
    }
    const data = cookies.get(key);
    if (!data || !data.trim() || data === "null" || data === "undefined") {
        return null;
    }
    return data;
}
let bigcommerceCartFetched = false;
function setBigcommerceCartToken() {
    if (bigcommerceCartFetched) {
        return;
    }
    API.get({
        url: location.origin + "/api/storefront/cart"
    }).then(r => {
        localStorage.setItem('__isp_cart', r[0].id);
        bigcommerceCartFetched = true;
    }).catch(e => {
        bigcommerceCartFetched = true;
    });
}
function getMagentoCartToken() {
    var _a;
    let token = "";
    const params = getScriptParamsByURL();
    if (params && "QuoteID" in params && params["QuoteID"]) {
        token = params["QuoteID"];
    }
    else if (typeof acp_magento_qvars !== "undefined" && typeof acp_magento_qvars.QuoteID !== "undefined") {
        token = acp_magento_qvars.QuoteID;
    }
    else if (typeof checkout !== "undefined" && ((_a = window.checkout) === null || _a === void 0 ? void 0 : _a.QuoteID)) {
        token = checkout.QuoteID;
    }
    else if (typeof isp_quote_id !== "undefined") {
        token = isp_quote_id;
    }
    if (token) {
        localStorage.setItem(SERP_CART_TOKEN_LS, token);
        return token;
    }
    return "";
}
function getWooCommerceCartToken() {
    const params = getScriptParamsByURL();
    if (params && "cart_token" in params && params["cart_token"]) {
        localStorage.setItem(SERP_CART_TOKEN_LS, params["cart_token"]);
        return params["cart_token"];
    }
    return "";
}
//# sourceMappingURL=cart.js.map